// The game record (design 2 §2.2). The core and its C ABI speak the canon byte form of the same
// messages (design 2 Appendix A); this file is the shape for the Go, TypeScript and Python services.
// Field numbers and canon tags are permanent. Every enum has an UNSPECIFIED = 0 member so an unset
// field is never read as a meaningful value.

// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file mj/record/v1/record.proto (package mj.record.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mj/record/v1/record.proto.
 */
export const file_mj_record_v1_record: GenFile = /*@__PURE__*/
  fileDesc("Chltai9yZWNvcmQvdjEvcmVjb3JkLnByb3RvEgxtai5yZWNvcmQudjEi8QIKCkdhbWVSZWNvcmQSFgoOcmVjb3JkX3ZlcnNpb24YASABKA0SDwoHZ2FtZV9pZBgCIAEoCRIlCgVydWxlcxgDIAEoCzIWLm1qLnJlY29yZC52MS5SdWxlc1JlZhIrCgpjb3JlX2J1aWxkGAQgASgLMhcubWoucmVjb3JkLnYxLkNvcmVCdWlsZBIsCgpwcm92ZW5hbmNlGAUgASgLMhgubWoucmVjb3JkLnYxLlByb3ZlbmFuY2USJQoHcGxheWVycxgGIAMoCzIULm1qLnJlY29yZC52MS5QbGF5ZXISJgoHc2h1ZmZsZRgHIAEoCzIVLm1qLnJlY29yZC52MS5TaHVmZmxlEiEKBWhhbmRzGAggAygLMhIubWoucmVjb3JkLnYxLkhhbmQSIgoDZW5kGAkgASgLMhUubWoucmVjb3JkLnYxLkdhbWVFbmQSIgoFdGFibGUYCiABKAsyEy5tai5yZWNvcmQudjEuVGFibGUiXAoFVGFibGUSDQoFcmF0ZWQYASABKAgSEAoIcXVldWVfaWQYAiABKAkSDAoEdGllchgDIAEoDRIkCgZjbG9ja3MYBCABKAsyFC5tai5yZWNvcmQudjEuQ2xvY2tzIjwKBkNsb2NrcxIPCgdiYXNlX21zGAEgASgNEg8KB2JhbmtfbXMYAiABKA0SEAoId19taW5fbXMYAyABKA0ibQoIUnVsZXNSZWYSKAoHdmFyaWFudBgBIAEoDjIXLm1qLnJlY29yZC52MS5WYXJpYW50SWQSFwoPbW9kdWxlX3JldmlzaW9uGAIgASgNEg4KBnByZXNldBgDIAEoDRIOCgZwYXJhbXMYBCABKAwiRwoJQ29yZUJ1aWxkEg8KB3ZlcnNpb24YASABKAkSEgoKZ2l0X2NvbW1pdBgCIAEoCRIVCg10YWJsZXNfc2hhMjU2GAMgASgMIsYCCgpQcm92ZW5hbmNlEi8KBnNvdXJjZRgBIAEoDjIfLm1qLnJlY29yZC52MS5Qcm92ZW5hbmNlLlNvdXJjZRIRCglzb3VyY2VfaWQYAiABKAkSFAoMc291cmNlX3J1bGVzGAMgASgJEhAKCGltcG9ydGVyGAQgASgJEhgKEGltcG9ydGVyX3ZlcnNpb24YBSABKAkSHwoXdGlsZV9pZGVudGl0eV9zeW50aGV0aWMYBiABKAgSFAoMd2FsbF91bmtub3duGAcgASgIEhkKEXJlc3BvbnNlc191bmtub3duGAggASgIImAKBlNvdXJjZRIWChJTT1VSQ0VfVU5TUEVDSUZJRUQQABIKCgZOQVRJVkUQARIOCgpURU5IT1VfWE1MEAISDwoLVEVOSE9VX0pTT04QAxIRCg1NSlNPVUxfVVBMT0FEEAQiUQoGUGxheWVyEhEKCXBsYXllcl9pZBgBIAEoCRIUCgxkaXNwbGF5X25hbWUYAiABKAkSCwoDYm90GAMgASgIEhEKCWVuZ2luZV9pZBgEIAEoCSLGAQoHU2h1ZmZsZRIRCglhbGdvcml0aG0YASABKAkSEgoKY29tbWl0bWVudBgCIAEoDBIcChRjb21taXRtZW50X3NpZ25hdHVyZRgDIAEoDBIXCg9jb21taXRtZW50X3RpbWUYBCABKAQSEwoLc2VydmVyX3NlZWQYBSABKAwSFQoNcGxheWVyX25vbmNlcxgGIAMoDBIQCghnYW1lX2tleRgHIAEoDBIPCgdzZWF0aW5nGAggAygJEg4KBmtleV9pZBgJIAEoDCKLAQoESGFuZBISCgpoYW5kX2luZGV4GAEgASgNEiYKBXN0YXJ0GAIgASgLMhcubWoucmVjb3JkLnYxLkhhbmRTdGFydBIjCgZldmVudHMYAyADKAsyEy5tai5yZWNvcmQudjEuRXZlbnQSIgoDZW5kGAQgASgLMhUubWoucmVjb3JkLnYxLkhhbmRFbmQi1wEKCUhhbmRTdGFydBIOCgZkZWFsZXIYASABKA0SDQoFcm91bmQYAiABKA0SFQoNaGFuZF9pbl9yb3VuZBgDIAEoDRIUCgxyZXBlYXRfY291bnQYBCABKA0SDgoGc3RpY2tzGAUgASgNEg4KBnBvaW50cxgGIAMoBRIQCghoYW5kX2tleRgHIAEoDBIMCgR3YWxsGAggAygNEiMKBmhhaXBhaRgJIAMoCzITLm1qLnJlY29yZC52MS5UaWxlcxIZChFpbml0aWFsX2luZGljYXRvchgKIAEoDSIUCgVUaWxlcxILCgNpZHMYASADKA0igAYKBUV2ZW50EgsKA3NlcRgBIAEoDRIsCgp2aXNpYmlsaXR5GAIgASgOMhgubWoucmVjb3JkLnYxLlZpc2liaWxpdHkSDAoEc2VhdBgDIAEoDRIiCgRkcmF3GAogASgLMhIubWoucmVjb3JkLnYxLkRyYXdIABIoCgdkaXNjYXJkGAsgASgLMhUubWoucmVjb3JkLnYxLkRpc2NhcmRIABIuCgZ3aW5kb3cYDCABKAsyHC5tai5yZWNvcmQudjEuUmVzcG9uc2VXaW5kb3dIABIwCgtkZWNsYXJhdGlvbhgNIAEoCzIZLm1qLnJlY29yZC52MS5EZWNsYXJhdGlvbkgAEiIKBGNhbGwYDiABKAsyEi5tai5yZWNvcmQudjEuQ2FsbEgAEiAKA2thbhgPIAEoCzIRLm1qLnJlY29yZC52MS5LYW5IABI0CgtyZXBsYWNlbWVudBgQIAEoCzIdLm1qLnJlY29yZC52MS5SZXBsYWNlbWVudERyYXdIABI0CglpbmRpY2F0b3IYESABKAsyHy5tai5yZWNvcmQudjEuSW5kaWNhdG9yUmV2ZWFsZWRIABIsCgVib251cxgSIAEoCzIbLm1qLnJlY29yZC52MS5Cb251c0RlY2xhcmVkSAASNwoPcmlpY2hpX2FjY2VwdGVkGBMgASgLMhwubWoucmVjb3JkLnYxLlJpaWNoaUFjY2VwdGVkSAASIAoDd2luGBQgASgLMhEubWoucmVjb3JkLnYxLldpbkgAEjIKCmV4aGF1c3RpdmUYFSABKAsyHC5tai5yZWNvcmQudjEuRXhoYXVzdGl2ZURyYXdIABIuCghhYm9ydGl2ZRgWIAEoCzIaLm1qLnJlY29yZC52MS5BYm9ydGl2ZURyYXdIABIoCgdwYXltZW50GBcgASgLMhUubWoucmVjb3JkLnYxLlBheW1lbnRIABItCgpleHRyYV9kcmF3GBggASgLMhcubWoucmVjb3JkLnYxLkV4dHJhRHJhd0gAQgYKBGJvZHkiLgoERHJhdxIMCgR0aWxlGAEgASgNEhgKEGZyb21fcmVwbGFjZW1lbnQYAiABKAgigQEKB0Rpc2NhcmQSDAoEdGlsZRgBIAEoDRIRCgl0c3Vtb2dpcmkYAiABKAgSGgoScmlpY2hpX2RlY2xhcmF0aW9uGAMgASgIEhEKCWJ5X3NlcnZlchgEIAEoCBImCgVzbG90cxgFIAEoCzIXLm1qLnJlY29yZC52MS5IYW5kU2xvdHMiOAoJSGFuZFNsb3RzEgwKBGZyb20YASABKA0SEQoJa2VwdF9kcmF3GAIgASgIEgoKAnRvGAMgASgNIkYKC0RlY2xhcmF0aW9uEiQKBmFjdGlvbhgBIAEoCzIULm1qLnJlY29yZC52MS5BY3Rpb24SEQoJYnlfc2VydmVyGAIgASgIIhAKDlJpaWNoaUFjY2VwdGVkIt0CCg5SZXNwb25zZVdpbmRvdxI1CgdzdWJqZWN0GAEgASgOMiQubWoucmVjb3JkLnYxLlJlc3BvbnNlV2luZG93LlN1YmplY3QSFAoMc3ViamVjdF90aWxlGAIgASgNEg0KBWFjdG9yGAMgASgNEhIKCnNlcXVlbnRpYWwYBCABKAgSKAoIZWxpZ2libGUYBSADKAsyFi5tai5yZWNvcmQudjEuRWxpZ2libGUSKQoJcmVzcG9uc2VzGAYgAygLMhYubWoucmVjb3JkLnYxLlJlc3BvbnNlEigKCHJlc29sdmVkGAcgASgLMhYubWoucmVjb3JkLnYxLlJlc3BvbnNlIlwKB1N1YmplY3QSFwoTU1VCSkVDVF9VTlNQRUNJRklFRBAAEgsKB0RJU0NBUkQQARIMCghLQU5fVElMRRACEg4KCkJPTlVTX1RJTEUQAxINCglMQVNUX1RJTEUQBCJBCghFbGlnaWJsZRIMCgRzZWF0GAEgASgNEicKBWxlZ2FsGAIgAygOMhgubWoucmVjb3JkLnYxLkFjdGlvblR5cGUicgoIUmVzcG9uc2USDAoEc2VhdBgBIAEoDRIkCgZhY3Rpb24YAiABKAsyFC5tai5yZWNvcmQudjEuQWN0aW9uEg8KB3Vua25vd24YAyABKAgSEQoJYnlfc2VydmVyGAQgASgIEg4KBmZvcmNlZBgFIAEoCCJQCgZBY3Rpb24SJgoEdHlwZRgBIAEoDjIYLm1qLnJlY29yZC52MS5BY3Rpb25UeXBlEg0KBXRpbGVzGAIgAygNEg8KB3BheWxvYWQYAyABKA0idAoEQ2FsbBImCgR0eXBlGAEgASgOMhgubWoucmVjb3JkLnYxLkFjdGlvblR5cGUSDQoFdGlsZXMYAiADKA0SEwoLY2FsbGVkX3RpbGUYAyABKA0SEQoJZnJvbV9zZWF0GAQgASgNEg0KBXNsb3RzGAUgAygNIksKA0thbhImCgR0eXBlGAEgASgOMhgubWoucmVjb3JkLnYxLkFjdGlvblR5cGUSDQoFdGlsZXMYAiADKA0SDQoFc2xvdHMYAyADKA0iMwoPUmVwbGFjZW1lbnREcmF3EgwKBHRpbGUYASABKA0SEgoKd2FsbF9pbmRleBgCIAEoDSIwChFJbmRpY2F0b3JSZXZlYWxlZBIMCgR0aWxlGAEgASgNEg0KBWluZGV4GAIgASgNIh0KDUJvbnVzRGVjbGFyZWQSDAoEdGlsZRgBIAEoDSLyAgoDV2luEg4KBndpbm5lchgBIAEoDRIRCglmcm9tX3NlYXQYAiABKA0SFAoMd2lubmluZ190aWxlGAMgASgNEhIKCnNlbGZfZHJhd24YBCABKAgSEwoLcm9iYmluZ19rYW4YBSABKAgSJgoJY29uY2VhbGVkGAYgASgLMhMubWoucmVjb3JkLnYxLlRpbGVzEiEKBW1lbGRzGAcgAygLMhIubWoucmVjb3JkLnYxLkNhbGwSDQoFYm9udXMYCCADKA0SJgoFaXRlbXMYCSADKAsyFy5tai5yZWNvcmQudjEuU2NvcmVJdGVtEgoKAmZ1GAogASgNEgsKA2hhbhgLIAEoDRITCgtiYXNlX3BvaW50cxgMIAEoBRIOCgZkZWx0YXMYDSADKAUSFgoObGlhYmlsaXR5X3NlYXQYDiABKA0SGQoRaGlkZGVuX2luZGljYXRvcnMYDyADKA0SFgoOdmFyaWFudF9kZXRhaWwYECABKAwiOQoJU2NvcmVJdGVtEgoKAmlkGAEgASgNEg0KBXZhbHVlGAIgASgFEhEKCXNvdXJjZV9pZBgDIAEoDSJWCg5FeGhhdXN0aXZlRHJhdxINCgVyZWFkeRgBIAMoCBIlCghyZXZlYWxlZBgCIAMoCzITLm1qLnJlY29yZC52MS5UaWxlcxIOCgZkZWx0YXMYAyADKAUiLgoMQWJvcnRpdmVEcmF3Eg4KBnJlYXNvbhgBIAEoDRIOCgZkZWx0YXMYAiADKAUiKQoHUGF5bWVudBIOCgZyZWFzb24YASABKA0SDgoGZGVsdGFzGAIgAygFIisKCUV4dHJhRHJhdxINCgV0aWxlcxgBIAMoDRIPCgdwdXJwb3NlGAIgASgNIqACCgdIYW5kRW5kEi4KB291dGNvbWUYASABKA4yHS5tai5yZWNvcmQudjEuSGFuZEVuZC5PdXRjb21lEg8KB3dpbm5lcnMYAiADKA0SDgoGcG9pbnRzGAMgAygFEhQKDHJlcGVhdF9jb3VudBgEIAEoDRIOCgZzdGlja3MYBSABKA0SEwoLbmV4dF9kZWFsZXIYBiABKA0SEQoJZ2FtZV9vdmVyGAcgASgIInYKB091dGNvbWUSFwoTT1VUQ09NRV9VTlNQRUNJRklFRBAAEgcKA1dJThABEhMKD0VYSEFVU1RJVkVfRFJBVxACEhEKDUFCT1JUSVZFX0RSQVcQAxIVChFBQk9SVEVEX0JZX1NFUlZFUhAEEgoKBlZPSURFRBAFItYCCgdHYW1lRW5kEg4KBnBvaW50cxgBIAMoBRIRCglwbGFjZW1lbnQYAiADKA0SEwoLc2NvcmVfeDEwMDAYAyADKAUSFwoPbGVmdG92ZXJfc3RpY2tzGAQgASgNEhkKEWV2ZW50X3N0cmVhbV9oYXNoGAUgASgMEhgKEGZpbmFsX3N0YXRlX2hhc2gYBiABKAwSMgoMZW5kZWRfcmVhc29uGAcgASgOMhwubWoucmVjb3JkLnYxLkdhbWVFbmQuUmVhc29uEhgKEHNlcnZlcl9zaWduYXR1cmUYCCABKAwSDgoGa2V5X2lkGAkgASgMEhAKCGVuZGVkX2F0GAogASgEIlUKBlJlYXNvbhIWChJSRUFTT05fVU5TUEVDSUZJRUQQABINCglDT01QTEVURUQQARINCglBQkFORE9ORUQQAhIVChFBQk9SVEVEX0JZX1NFUlZFUhADKmUKCVZhcmlhbnRJZBIXChNWQVJJQU5UX1VOU1BFQ0lGSUVEEAASCgoGUklJQ0hJEAESDQoJVEFJV0FORVNFEAISDAoIQ0hBTkdTSEEQAxIHCgNNQ1IQBBINCglIT05HX0tPTkcQBSpOCgpWaXNpYmlsaXR5EhoKFlZJU0lCSUxJVFlfVU5TUEVDSUZJRUQQABIKCgZQVUJMSUMQARIICgRTRUFUEAISDgoKT01OSVNDSUVOVBADKu4BCgpBY3Rpb25UeXBlEhYKEkFDVElPTl9VTlNQRUNJRklFRBAAEgsKB0RJU0NBUkQQARIHCgNDSEkQAhIHCgNQT04QAxIMCghPUEVOX0tBThAEEg0KCUFEREVEX0tBThAFEg4KCkNMT1NFRF9LQU4QBhIHCgNST04QBxIJCgVUU1VNTxAIEggKBFBBU1MQCRISCg5ERUNMQVJFX1JJSUNISRAKEhEKDUFCT1JUSVZFX0RSQVcQCxIZChVERUNMQVJFX1NUQVJUSU5HX0hBTkQQDBISCg5UQUtFX0xBU1RfVElMRRANEggKBEtJVEEQDmIGcHJvdG8z");

/**
 * @generated from message mj.record.v1.GameRecord
 */
export type GameRecord = Message<"mj.record.v1.GameRecord"> & {
  /**
   * 1
   *
   * @generated from field: uint32 record_version = 1;
   */
  recordVersion: number;

  /**
   * UUIDv7 as the 36-character text form, assigned by the server at table creation
   *
   * @generated from field: string game_id = 2;
   */
  gameId: string;

  /**
   * @generated from field: mj.record.v1.RulesRef rules = 3;
   */
  rules?: RulesRef | undefined;

  /**
   * the build that produced the record (native game server)
   *
   * @generated from field: mj.record.v1.CoreBuild core_build = 4;
   */
  coreBuild?: CoreBuild | undefined;

  /**
   * @generated from field: mj.record.v1.Provenance provenance = 5;
   */
  provenance?: Provenance | undefined;

  /**
   * index = seat at game start; seat 0 is the first dealer
   *
   * @generated from field: repeated mj.record.v1.Player players = 6;
   */
  players: Player[];

  /**
   * @generated from field: mj.record.v1.Shuffle shuffle = 7;
   */
  shuffle?: Shuffle | undefined;

  /**
   * @generated from field: repeated mj.record.v1.Hand hands = 8;
   */
  hands: Hand[];

  /**
   * absent while the game is in progress
   *
   * @generated from field: mj.record.v1.GameEnd end = 9;
   */
  end?: GameEnd | undefined;

  /**
   * rated, queue, tier, clocks: chosen by the gateway and committed before the nonces (design 2 §3.2)
   *
   * @generated from field: mj.record.v1.Table table = 10;
   */
  table?: Table | undefined;
};

/**
 * Describes the message mj.record.v1.GameRecord.
 * Use `create(GameRecordSchema)` to create a new message.
 */
export const GameRecordSchema: GenMessage<GameRecord> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 0);

/**
 * canon tag 20 (commitment input).
 *
 * @generated from message mj.record.v1.Table
 */
export type Table = Message<"mj.record.v1.Table"> & {
  /**
   * @generated from field: bool rated = 1;
   */
  rated: boolean;

  /**
   * "riichi4.rated"
   *
   * @generated from field: string queue_id = 2;
   */
  queueId: string;

  /**
   * @generated from field: uint32 tier = 3;
   */
  tier: number;

  /**
   * @generated from field: mj.record.v1.Clocks clocks = 4;
   */
  clocks?: Clocks | undefined;
};

/**
 * Describes the message mj.record.v1.Table.
 * Use `create(TableSchema)` to create a new message.
 */
export const TableSchema: GenMessage<Table> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 1);

/**
 * 10,000 / 20,000 / 1,000 for the rated preset (design 4 §5).
 *
 * @generated from message mj.record.v1.Clocks
 */
export type Clocks = Message<"mj.record.v1.Clocks"> & {
  /**
   * @generated from field: uint32 base_ms = 1;
   */
  baseMs: number;

  /**
   * @generated from field: uint32 bank_ms = 2;
   */
  bankMs: number;

  /**
   * @generated from field: uint32 w_min_ms = 3;
   */
  wMinMs: number;
};

/**
 * Describes the message mj.record.v1.Clocks.
 * Use `create(ClocksSchema)` to create a new message.
 */
export const ClocksSchema: GenMessage<Clocks> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 2);

/**
 * canon tag 19 (commitment input).
 *
 * @generated from message mj.record.v1.RulesRef
 */
export type RulesRef = Message<"mj.record.v1.RulesRef"> & {
  /**
   * RIICHI
   *
   * @generated from field: mj.record.v1.VariantId variant = 1;
   */
  variant: VariantId;

  /**
   * 1
   *
   * @generated from field: uint32 module_revision = 2;
   */
  moduleRevision: number;

  /**
   * module enum, e.g. mj.riichi.v1.Preset
   *
   * @generated from field: uint32 preset = 3;
   */
  preset: number;

  /**
   * the module's Params message (mj.riichi.v1.Params), canon-encoded
   *
   * @generated from field: bytes params = 4;
   */
  params: Uint8Array;
};

/**
 * Describes the message mj.record.v1.RulesRef.
 * Use `create(RulesRefSchema)` to create a new message.
 */
export const RulesRefSchema: GenMessage<RulesRef> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 3);

/**
 * @generated from message mj.record.v1.CoreBuild
 */
export type CoreBuild = Message<"mj.record.v1.CoreBuild"> & {
  /**
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * @generated from field: string git_commit = 2;
   */
  gitCommit: string;

  /**
   * @generated from field: bytes tables_sha256 = 3;
   */
  tablesSha256: Uint8Array;
};

/**
 * Describes the message mj.record.v1.CoreBuild.
 * Use `create(CoreBuildSchema)` to create a new message.
 */
export const CoreBuildSchema: GenMessage<CoreBuild> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 4);

/**
 * @generated from message mj.record.v1.Provenance
 */
export type Provenance = Message<"mj.record.v1.Provenance"> & {
  /**
   * @generated from field: mj.record.v1.Provenance.Source source = 1;
   */
  source: Provenance_Source;

  /**
   * Tenhou log id, Mahjong Soul uuid; empty for NATIVE
   *
   * @generated from field: string source_id = 2;
   */
  sourceId: string;

  /**
   * display string as the source gave it ("四鳳南喰赤", "玉の間 四人南")
   *
   * @generated from field: string source_rules = 3;
   */
  sourceRules: string;

  /**
   * @generated from field: string importer = 4;
   */
  importer: string;

  /**
   * @generated from field: string importer_version = 5;
   */
  importerVersion: string;

  /**
   * copies assigned by the importer, not by the source
   *
   * @generated from field: bool tile_identity_synthetic = 6;
   */
  tileIdentitySynthetic: boolean;

  /**
   * the wall could not be recomputed
   *
   * @generated from field: bool wall_unknown = 7;
   */
  wallUnknown: boolean;

  /**
   * declined claims were not recorded by the source (Tenhou)
   *
   * @generated from field: bool responses_unknown = 8;
   */
  responsesUnknown: boolean;
};

/**
 * Describes the message mj.record.v1.Provenance.
 * Use `create(ProvenanceSchema)` to create a new message.
 */
export const ProvenanceSchema: GenMessage<Provenance> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 5);

/**
 * @generated from enum mj.record.v1.Provenance.Source
 */
export enum Provenance_Source {
  /**
   * @generated from enum value: SOURCE_UNSPECIFIED = 0;
   */
  SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NATIVE = 1;
   */
  NATIVE = 1,

  /**
   * @generated from enum value: TENHOU_XML = 2;
   */
  TENHOU_XML = 2,

  /**
   * @generated from enum value: TENHOU_JSON = 3;
   */
  TENHOU_JSON = 3,

  /**
   * @generated from enum value: MJSOUL_UPLOAD = 4;
   */
  MJSOUL_UPLOAD = 4,
}

/**
 * Describes the enum mj.record.v1.Provenance.Source.
 */
export const Provenance_SourceSchema: GenEnum<Provenance_Source> = /*@__PURE__*/
  enumDesc(file_mj_record_v1_record, 5, 0);

/**
 * @generated from message mj.record.v1.Player
 */
export type Player = Message<"mj.record.v1.Player"> & {
  /**
   * Namespaced: "acct:<public id>" for platform accounts (a public, stable id, never the database id),
   * "tenhou:<hash>", "mjs:<hash>" for imports (names of third parties are hashed).
   *
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * platform display name; empty for imported third parties
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: bool bot = 3;
   */
  bot: boolean;

  /**
   * design 3 engine identity when bot = true
   *
   * @generated from field: string engine_id = 4;
   */
  engineId: string;
};

/**
 * Describes the message mj.record.v1.Player.
 * Use `create(PlayerSchema)` to create a new message.
 */
export const PlayerSchema: GenMessage<Player> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 6);

/**
 * @generated from message mj.record.v1.Shuffle
 */
export type Shuffle = Message<"mj.record.v1.Shuffle"> & {
  /**
   * "wall-sha256-fy-v1"; imports: "tenhou-mt19937ar-sha512-n288", "unknown"
   *
   * @generated from field: string algorithm = 1;
   */
  algorithm: string;

  /**
   * 32 bytes (design 2 §3.2), shown to all seats before any nonce was sent
   *
   * @generated from field: bytes commitment = 2;
   */
  commitment: Uint8Array;

  /**
   * Ed25519 over "mj-commit-sig-v1" ‖ L(game_id) ‖ commitment ‖ u64le(commitment_time)
   *
   * @generated from field: bytes commitment_signature = 3;
   */
  commitmentSignature: Uint8Array;

  /**
   * unix seconds, part of the signed message
   *
   * @generated from field: uint64 commitment_time = 4;
   */
  commitmentTime: bigint;

  /**
   * 32 bytes; empty until the game ends (live view) or when unknown (imports)
   *
   * @generated from field: bytes server_seed = 5;
   */
  serverSeed: Uint8Array;

  /**
   * 16 bytes per seat, fresh per commitment; always present for NATIVE
   *
   * @generated from field: repeated bytes player_nonces = 6;
   */
  playerNonces: Uint8Array[];

  /**
   * derived (design 2 §3.2); stored for convenience, recomputed by the verifier
   *
   * @generated from field: bytes game_key = 7;
   */
  gameKey: Uint8Array;

  /**
   * player ids in seat order, exactly as hashed into commitment and game_key
   *
   * @generated from field: repeated string seating = 8;
   */
  seating: string[];

  /**
   * 8 bytes: SHA-256(server public key)[0..8]; the key list is published (design 4 §8)
   *
   * @generated from field: bytes key_id = 9;
   */
  keyId: Uint8Array;
};

/**
 * Describes the message mj.record.v1.Shuffle.
 * Use `create(ShuffleSchema)` to create a new message.
 */
export const ShuffleSchema: GenMessage<Shuffle> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 7);

/**
 * @generated from message mj.record.v1.Hand
 */
export type Hand = Message<"mj.record.v1.Hand"> & {
  /**
   * 0,1,2,... including repeated hands
   *
   * @generated from field: uint32 hand_index = 1;
   */
  handIndex: number;

  /**
   * canon tag 16
   *
   * @generated from field: mj.record.v1.HandStart start = 2;
   */
  start?: HandStart | undefined;

  /**
   * @generated from field: repeated mj.record.v1.Event events = 3;
   */
  events: Event[];

  /**
   * checkpoint, canon tag 17
   *
   * @generated from field: mj.record.v1.HandEnd end = 4;
   */
  end?: HandEnd | undefined;
};

/**
 * Describes the message mj.record.v1.Hand.
 * Use `create(HandSchema)` to create a new message.
 */
export const HandSchema: GenMessage<Hand> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 8);

/**
 * @generated from message mj.record.v1.HandStart
 */
export type HandStart = Message<"mj.record.v1.HandStart"> & {
  /**
   * @generated from field: uint32 dealer = 1;
   */
  dealer: number;

  /**
   * 0 = East, 1 = South, 2 = West
   *
   * @generated from field: uint32 round = 2;
   */
  round: number;

  /**
   * @generated from field: uint32 hand_in_round = 3;
   */
  handInRound: number;

  /**
   * honba
   *
   * @generated from field: uint32 repeat_count = 4;
   */
  repeatCount: number;

  /**
   * riichi deposits carried over
   *
   * @generated from field: uint32 sticks = 5;
   */
  sticks: number;

  /**
   * per seat, before the hand
   *
   * @generated from field: repeated int32 points = 6;
   */
  points: number[];

  /**
   * derived (design 2 §3.2); empty in seat views until GameEnd
   *
   * @generated from field: bytes hand_key = 7;
   */
  handKey: Uint8Array;

  /**
   * the full permutation of tile ids; empty when wall_unknown (visibility OMNISCIENT)
   *
   * @generated from field: repeated uint32 wall = 8;
   */
  wall: number[];

  /**
   * per seat, the dealt tiles in dealing order (visibility SEAT per entry)
   *
   * @generated from field: repeated mj.record.v1.Tiles haipai = 9;
   */
  haipai: Tiles[];

  /**
   * Riichi: dora indicator tile id; 0xFFFF when not applicable
   *
   * @generated from field: uint32 initial_indicator = 10;
   */
  initialIndicator: number;
};

/**
 * Describes the message mj.record.v1.HandStart.
 * Use `create(HandStartSchema)` to create a new message.
 */
export const HandStartSchema: GenMessage<HandStart> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 9);

/**
 * @generated from message mj.record.v1.Tiles
 */
export type Tiles = Message<"mj.record.v1.Tiles"> & {
  /**
   * @generated from field: repeated uint32 ids = 1;
   */
  ids: number[];
};

/**
 * Describes the message mj.record.v1.Tiles.
 * Use `create(TilesSchema)` to create a new message.
 */
export const TilesSchema: GenMessage<Tiles> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 10);

/**
 * @generated from message mj.record.v1.Event
 */
export type Event = Message<"mj.record.v1.Event"> & {
  /**
   * 0-based within the hand; preserved in every view (blanking, not removal)
   *
   * @generated from field: uint32 seq = 1;
   */
  seq: number;

  /**
   * @generated from field: mj.record.v1.Visibility visibility = 2;
   */
  visibility: Visibility;

  /**
   * the acting or receiving seat; 255 when not seat-specific
   *
   * @generated from field: uint32 seat = 3;
   */
  seat: number;

  /**
   * @generated from oneof mj.record.v1.Event.body
   */
  body: {
    /**
     * SEAT
     *
     * @generated from field: mj.record.v1.Draw draw = 10;
     */
    value: Draw;
    case: "draw";
  } | {
    /**
     * PUBLIC; a decision
     *
     * @generated from field: mj.record.v1.Discard discard = 11;
     */
    value: Discard;
    case: "discard";
  } | {
    /**
     * PUBLIC shell; per-seat eligibility and responses inside
     *
     * @generated from field: mj.record.v1.ResponseWindow window = 12;
     */
    value: ResponseWindow;
    case: "window";
  } | {
    /**
     * PUBLIC; a decision: riichi, tsumo, kans, abort, starting hand, kita, take last tile, and the Pass of a sequential or pre-discard prompt
     *
     * @generated from field: mj.record.v1.Declaration declaration = 13;
     */
    value: Declaration;
    case: "declaration";
  } | {
    /**
     * derived from a window resolution: chi, pon, open kan
     *
     * @generated from field: mj.record.v1.Call call = 14;
     */
    value: Call;
    case: "call";
  } | {
    /**
     * derived from a Declaration: added or closed kan
     *
     * @generated from field: mj.record.v1.Kan kan = 15;
     */
    value: Kan;
    case: "kan";
  } | {
    /**
     * SEAT
     *
     * @generated from field: mj.record.v1.ReplacementDraw replacement = 16;
     */
    value: ReplacementDraw;
    case: "replacement";
  } | {
    /**
     * PUBLIC (kan dora); hidden indicators are never separate events, see Win
     *
     * @generated from field: mj.record.v1.IndicatorRevealed indicator = 17;
     */
    value: IndicatorRevealed;
    case: "indicator";
  } | {
    /**
     * PUBLIC
     *
     * @generated from field: mj.record.v1.BonusDeclared bonus = 18;
     */
    value: BonusDeclared;
    case: "bonus";
  } | {
    /**
     * derived
     *
     * @generated from field: mj.record.v1.RiichiAccepted riichi_accepted = 19;
     */
    value: RiichiAccepted;
    case: "riichiAccepted";
  } | {
    /**
     * derived; one per winner
     *
     * @generated from field: mj.record.v1.Win win = 20;
     */
    value: Win;
    case: "win";
  } | {
    /**
     * @generated from field: mj.record.v1.ExhaustiveDraw exhaustive = 21;
     */
    value: ExhaustiveDraw;
    case: "exhaustive";
  } | {
    /**
     * @generated from field: mj.record.v1.AbortiveDraw abortive = 22;
     */
    value: AbortiveDraw;
    case: "abortive";
  } | {
    /**
     * derived: points moved outside a win (deposit, noten, starting hands)
     *
     * @generated from field: mj.record.v1.Payment payment = 23;
     */
    value: Payment;
    case: "payment";
  } | {
    /**
     * derived: tiles drawn after a win (Changsha birds)
     *
     * @generated from field: mj.record.v1.ExtraDraw extra_draw = 24;
     */
    value: ExtraDraw;
    case: "extraDraw";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mj.record.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 11);

/**
 * @generated from message mj.record.v1.Draw
 */
export type Draw = Message<"mj.record.v1.Draw"> & {
  /**
   * 65535 when blanked
   *
   * @generated from field: uint32 tile = 1;
   */
  tile: number;

  /**
   * @generated from field: bool from_replacement = 2;
   */
  fromReplacement: boolean;
};

/**
 * Describes the message mj.record.v1.Draw.
 * Use `create(DrawSchema)` to create a new message.
 */
export const DrawSchema: GenMessage<Draw> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 12);

/**
 * @generated from message mj.record.v1.Discard
 */
export type Discard = Message<"mj.record.v1.Discard"> & {
  /**
   * @generated from field: uint32 tile = 1;
   */
  tile: number;

  /**
   * @generated from field: bool tsumogiri = 2;
   */
  tsumogiri: boolean;

  /**
   * @generated from field: bool riichi_declaration = 3;
   */
  riichiDeclaration: boolean;

  /**
   * @generated from field: bool by_server = 4;
   */
  byServer: boolean;

  /**
   * presentation (design 8 §2): not in canon, not hashed, not signed
   *
   * @generated from field: mj.record.v1.HandSlots slots = 5;
   */
  slots?: HandSlots | undefined;
};

/**
 * Describes the message mj.record.v1.Discard.
 * Use `create(DiscardSchema)` to create a new message.
 */
export const DiscardSchema: GenMessage<Discard> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 13);

/**
 * Where a discard left its seat's hand, and where the kept drawn tile went, as the player's client arranged
 * the hand (sorted, for bots and server-played discards): what a physical table shows (design 8 §2).
 *
 * @generated from message mj.record.v1.HandSlots
 */
export type HandSlots = Message<"mj.record.v1.HandSlots"> & {
  /**
   * 0-based, left to right; while a drawn tile is apart it is the last slot
   *
   * @generated from field: uint32 from = 1;
   */
  from: number;

  /**
   * a tile other than the drawn one went: the drawn tile moved into slot `to`
   *
   * @generated from field: bool kept_draw = 2;
   */
  keptDraw: boolean;

  /**
   * 0-based, in the hand after the discard
   *
   * @generated from field: uint32 to = 3;
   */
  to: number;
};

/**
 * Describes the message mj.record.v1.HandSlots.
 * Use `create(HandSlotsSchema)` to create a new message.
 */
export const HandSlotsSchema: GenMessage<HandSlots> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 14);

/**
 * @generated from message mj.record.v1.Declaration
 */
export type Declaration = Message<"mj.record.v1.Declaration"> & {
  /**
   * @generated from field: mj.record.v1.Action action = 1;
   */
  action?: Action | undefined;

  /**
   * @generated from field: bool by_server = 2;
   */
  byServer: boolean;
};

/**
 * Describes the message mj.record.v1.Declaration.
 * Use `create(DeclarationSchema)` to create a new message.
 */
export const DeclarationSchema: GenMessage<Declaration> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 15);

/**
 * @generated from message mj.record.v1.RiichiAccepted
 */
export type RiichiAccepted = Message<"mj.record.v1.RiichiAccepted"> & {
};

/**
 * Describes the message mj.record.v1.RiichiAccepted.
 * Use `create(RiichiAcceptedSchema)` to create a new message.
 */
export const RiichiAcceptedSchema: GenMessage<RiichiAccepted> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 16);

/**
 * @generated from message mj.record.v1.ResponseWindow
 */
export type ResponseWindow = Message<"mj.record.v1.ResponseWindow"> & {
  /**
   * @generated from field: mj.record.v1.ResponseWindow.Subject subject = 1;
   */
  subject: ResponseWindow_Subject;

  /**
   * @generated from field: uint32 subject_tile = 2;
   */
  subjectTile: number;

  /**
   * who discarded / declared the kan / declared the bonus tile
   *
   * @generated from field: uint32 actor = 3;
   */
  actor: number;

  /**
   * seats asked one at a time in seat order; only asked seats carry an action
   *
   * @generated from field: bool sequential = 4;
   */
  sequential: boolean;

  /**
   * Exactly `seats` entries in seat order, in the record and in every view; each payload is visible to its
   * own seat only, so a blanked entry and an ineligible seat's (empty `legal`) are indistinguishable.
   *
   * @generated from field: repeated mj.record.v1.Eligible eligible = 5;
   */
  eligible: Eligible[];

  /**
   * Exactly `seats` entries in seat order; a seat that was not asked has no action; payload visibility SEAT.
   *
   * @generated from field: repeated mj.record.v1.Response responses = 6;
   */
  responses: Response[];

  /**
   * PUBLIC: what the core selected after arbitration (PASS when nobody claimed)
   *
   * @generated from field: mj.record.v1.Response resolved = 7;
   */
  resolved?: Response | undefined;
};

/**
 * Describes the message mj.record.v1.ResponseWindow.
 * Use `create(ResponseWindowSchema)` to create a new message.
 */
export const ResponseWindowSchema: GenMessage<ResponseWindow> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 17);

/**
 * @generated from enum mj.record.v1.ResponseWindow.Subject
 */
export enum ResponseWindow_Subject {
  /**
   * @generated from enum value: SUBJECT_UNSPECIFIED = 0;
   */
  SUBJECT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DISCARD = 1;
   */
  DISCARD = 1,

  /**
   * @generated from enum value: KAN_TILE = 2;
   */
  KAN_TILE = 2,

  /**
   * @generated from enum value: BONUS_TILE = 3;
   */
  BONUS_TILE = 3,

  /**
   * @generated from enum value: LAST_TILE = 4;
   */
  LAST_TILE = 4,
}

/**
 * Describes the enum mj.record.v1.ResponseWindow.Subject.
 */
export const ResponseWindow_SubjectSchema: GenEnum<ResponseWindow_Subject> = /*@__PURE__*/
  enumDesc(file_mj_record_v1_record, 17, 0);

/**
 * @generated from message mj.record.v1.Eligible
 */
export type Eligible = Message<"mj.record.v1.Eligible"> & {
  /**
   * @generated from field: uint32 seat = 1;
   */
  seat: number;

  /**
   * @generated from field: repeated mj.record.v1.ActionType legal = 2;
   */
  legal: ActionType[];
};

/**
 * Describes the message mj.record.v1.Eligible.
 * Use `create(EligibleSchema)` to create a new message.
 */
export const EligibleSchema: GenMessage<Eligible> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 18);

/**
 * @generated from message mj.record.v1.Response
 */
export type Response = Message<"mj.record.v1.Response"> & {
  /**
   * @generated from field: uint32 seat = 1;
   */
  seat: number;

  /**
   * @generated from field: mj.record.v1.Action action = 2;
   */
  action?: Action | undefined;

  /**
   * imports: the source did not record this seat's answer
   *
   * @generated from field: bool unknown = 3;
   */
  unknown: boolean;

  /**
   * @generated from field: bool by_server = 4;
   */
  byServer: boolean;

  /**
   * compelled (Changsha 通炮); not a decision
   *
   * @generated from field: bool forced = 5;
   */
  forced: boolean;
};

/**
 * Describes the message mj.record.v1.Response.
 * Use `create(ResponseSchema)` to create a new message.
 */
export const ResponseSchema: GenMessage<Response> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 19);

/**
 * @generated from message mj.record.v1.Action
 */
export type Action = Message<"mj.record.v1.Action"> & {
  /**
   * @generated from field: mj.record.v1.ActionType type = 1;
   */
  type: ActionType;

  /**
   * consumed/declared tiles, by id
   *
   * @generated from field: repeated uint32 tiles = 2;
   */
  tiles: number[];

  /**
   * variant-defined small argument
   *
   * @generated from field: uint32 payload = 3;
   */
  payload: number;
};

/**
 * Describes the message mj.record.v1.Action.
 * Use `create(ActionSchema)` to create a new message.
 */
export const ActionSchema: GenMessage<Action> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 20);

/**
 * @generated from message mj.record.v1.Call
 */
export type Call = Message<"mj.record.v1.Call"> & {
  /**
   * @generated from field: mj.record.v1.ActionType type = 1;
   */
  type: ActionType;

  /**
   * @generated from field: repeated uint32 tiles = 2;
   */
  tiles: number[];

  /**
   * @generated from field: uint32 called_tile = 3;
   */
  calledTile: number;

  /**
   * @generated from field: uint32 from_seat = 4;
   */
  fromSeat: number;

  /**
   * The hand slots the tiles used left, ascending, as the caller's hand showed them (0-based, left to right;
   * sorted for bots and server-played calls): what a physical table shows (design 10 T11). Presentation:
   * not in canon, not hashed, not signed, and never set on a Win's melds.
   *
   * @generated from field: repeated uint32 slots = 5;
   */
  slots: number[];
};

/**
 * Describes the message mj.record.v1.Call.
 * Use `create(CallSchema)` to create a new message.
 */
export const CallSchema: GenMessage<Call> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 21);

/**
 * @generated from message mj.record.v1.Kan
 */
export type Kan = Message<"mj.record.v1.Kan"> & {
  /**
   * @generated from field: mj.record.v1.ActionType type = 1;
   */
  type: ActionType;

  /**
   * @generated from field: repeated uint32 tiles = 2;
   */
  tiles: number[];

  /**
   * as a Call's: where the tiles from the hand left it (design 10 T11)
   *
   * @generated from field: repeated uint32 slots = 3;
   */
  slots: number[];
};

/**
 * Describes the message mj.record.v1.Kan.
 * Use `create(KanSchema)` to create a new message.
 */
export const KanSchema: GenMessage<Kan> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 22);

/**
 * wall_index: absolute index in the permutation (dice-indexed draws need it).
 *
 * @generated from message mj.record.v1.ReplacementDraw
 */
export type ReplacementDraw = Message<"mj.record.v1.ReplacementDraw"> & {
  /**
   * @generated from field: uint32 tile = 1;
   */
  tile: number;

  /**
   * @generated from field: uint32 wall_index = 2;
   */
  wallIndex: number;
};

/**
 * Describes the message mj.record.v1.ReplacementDraw.
 * Use `create(ReplacementDrawSchema)` to create a new message.
 */
export const ReplacementDrawSchema: GenMessage<ReplacementDraw> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 23);

/**
 * @generated from message mj.record.v1.IndicatorRevealed
 */
export type IndicatorRevealed = Message<"mj.record.v1.IndicatorRevealed"> & {
  /**
   * @generated from field: uint32 tile = 1;
   */
  tile: number;

  /**
   * absolute index in the permutation (design 2 Appendix A)
   *
   * @generated from field: uint32 index = 2;
   */
  index: number;
};

/**
 * Describes the message mj.record.v1.IndicatorRevealed.
 * Use `create(IndicatorRevealedSchema)` to create a new message.
 */
export const IndicatorRevealedSchema: GenMessage<IndicatorRevealed> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 24);

/**
 * @generated from message mj.record.v1.BonusDeclared
 */
export type BonusDeclared = Message<"mj.record.v1.BonusDeclared"> & {
  /**
   * @generated from field: uint32 tile = 1;
   */
  tile: number;
};

/**
 * Describes the message mj.record.v1.BonusDeclared.
 * Use `create(BonusDeclaredSchema)` to create a new message.
 */
export const BonusDeclaredSchema: GenMessage<BonusDeclared> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 25);

/**
 * @generated from message mj.record.v1.Win
 */
export type Win = Message<"mj.record.v1.Win"> & {
  /**
   * @generated from field: uint32 winner = 1;
   */
  winner: number;

  /**
   * discarder; == winner for a self-draw
   *
   * @generated from field: uint32 from_seat = 2;
   */
  fromSeat: number;

  /**
   * @generated from field: uint32 winning_tile = 3;
   */
  winningTile: number;

  /**
   * @generated from field: bool self_drawn = 4;
   */
  selfDrawn: boolean;

  /**
   * @generated from field: bool robbing_kan = 5;
   */
  robbingKan: boolean;

  /**
   * the winner's concealed tiles at the win (including the winning tile)
   *
   * @generated from field: mj.record.v1.Tiles concealed = 6;
   */
  concealed?: Tiles | undefined;

  /**
   * @generated from field: repeated mj.record.v1.Call melds = 7;
   */
  melds: Call[];

  /**
   * @generated from field: repeated uint32 bonus = 8;
   */
  bonus: number[];

  /**
   * registry ids with values
   *
   * @generated from field: repeated mj.record.v1.ScoreItem items = 9;
   */
  items: ScoreItem[];

  /**
   * Riichi; 0 for variants that do not use it
   *
   * @generated from field: uint32 fu = 10;
   */
  fu: number;

  /**
   * Riichi; 0 for variants that do not use it
   *
   * @generated from field: uint32 han = 11;
   */
  han: number;

  /**
   * @generated from field: int32 base_points = 12;
   */
  basePoints: number;

  /**
   * per seat, including counters and deposits
   *
   * @generated from field: repeated int32 deltas = 13;
   */
  deltas: number[];

  /**
   * pao; 255 if none
   *
   * @generated from field: uint32 liability_seat = 14;
   */
  liabilitySeat: number;

  /**
   * ura dora revealed for this win (the only place hidden indicators appear)
   *
   * @generated from field: repeated uint32 hidden_indicators = 15;
   */
  hiddenIndicators: number[];

  /**
   * variant-specific breakdown message; NOT in canon, NOT hashed
   *
   * @generated from field: bytes variant_detail = 16;
   */
  variantDetail: Uint8Array;
};

/**
 * Describes the message mj.record.v1.Win.
 * Use `create(WinSchema)` to create a new message.
 */
export const WinSchema: GenMessage<Win> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 26);

/**
 * id from the module's registry; source_id = Tenhou/MJS id on imports.
 *
 * @generated from message mj.record.v1.ScoreItem
 */
export type ScoreItem = Message<"mj.record.v1.ScoreItem"> & {
  /**
   * @generated from field: uint32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 value = 2;
   */
  value: number;

  /**
   * @generated from field: uint32 source_id = 3;
   */
  sourceId: number;
};

/**
 * Describes the message mj.record.v1.ScoreItem.
 * Use `create(ScoreItemSchema)` to create a new message.
 */
export const ScoreItemSchema: GenMessage<ScoreItem> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 27);

/**
 * @generated from message mj.record.v1.ExhaustiveDraw
 */
export type ExhaustiveDraw = Message<"mj.record.v1.ExhaustiveDraw"> & {
  /**
   * @generated from field: repeated bool ready = 1;
   */
  ready: boolean[];

  /**
   * @generated from field: repeated mj.record.v1.Tiles revealed = 2;
   */
  revealed: Tiles[];

  /**
   * @generated from field: repeated int32 deltas = 3;
   */
  deltas: number[];
};

/**
 * Describes the message mj.record.v1.ExhaustiveDraw.
 * Use `create(ExhaustiveDrawSchema)` to create a new message.
 */
export const ExhaustiveDrawSchema: GenMessage<ExhaustiveDraw> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 28);

/**
 * @generated from message mj.record.v1.AbortiveDraw
 */
export type AbortiveDraw = Message<"mj.record.v1.AbortiveDraw"> & {
  /**
   * module enum
   *
   * @generated from field: uint32 reason = 1;
   */
  reason: number;

  /**
   * @generated from field: repeated int32 deltas = 2;
   */
  deltas: number[];
};

/**
 * Describes the message mj.record.v1.AbortiveDraw.
 * Use `create(AbortiveDrawSchema)` to create a new message.
 */
export const AbortiveDrawSchema: GenMessage<AbortiveDraw> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 29);

/**
 * @generated from message mj.record.v1.Payment
 */
export type Payment = Message<"mj.record.v1.Payment"> & {
  /**
   * module enum: DEPOSIT, NOTEN, STARTING_HAND_*, ...
   *
   * @generated from field: uint32 reason = 1;
   */
  reason: number;

  /**
   * @generated from field: repeated int32 deltas = 2;
   */
  deltas: number[];
};

/**
 * Describes the message mj.record.v1.Payment.
 * Use `create(PaymentSchema)` to create a new message.
 */
export const PaymentSchema: GenMessage<Payment> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 30);

/**
 * @generated from message mj.record.v1.ExtraDraw
 */
export type ExtraDraw = Message<"mj.record.v1.ExtraDraw"> & {
  /**
   * @generated from field: repeated uint32 tiles = 1;
   */
  tiles: number[];

  /**
   * module enum: BIRD
   *
   * @generated from field: uint32 purpose = 2;
   */
  purpose: number;
};

/**
 * Describes the message mj.record.v1.ExtraDraw.
 * Use `create(ExtraDrawSchema)` to create a new message.
 */
export const ExtraDrawSchema: GenMessage<ExtraDraw> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 31);

/**
 * @generated from message mj.record.v1.HandEnd
 */
export type HandEnd = Message<"mj.record.v1.HandEnd"> & {
  /**
   * @generated from field: mj.record.v1.HandEnd.Outcome outcome = 1;
   */
  outcome: HandEnd_Outcome;

  /**
   * @generated from field: repeated uint32 winners = 2;
   */
  winners: number[];

  /**
   * per seat, after settlement
   *
   * @generated from field: repeated int32 points = 3;
   */
  points: number[];

  /**
   * @generated from field: uint32 repeat_count = 4;
   */
  repeatCount: number;

  /**
   * @generated from field: uint32 sticks = 5;
   */
  sticks: number;

  /**
   * @generated from field: uint32 next_dealer = 6;
   */
  nextDealer: number;

  /**
   * @generated from field: bool game_over = 7;
   */
  gameOver: boolean;
};

/**
 * Describes the message mj.record.v1.HandEnd.
 * Use `create(HandEndSchema)` to create a new message.
 */
export const HandEndSchema: GenMessage<HandEnd> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 32);

/**
 * @generated from enum mj.record.v1.HandEnd.Outcome
 */
export enum HandEnd_Outcome {
  /**
   * @generated from enum value: OUTCOME_UNSPECIFIED = 0;
   */
  OUTCOME_UNSPECIFIED = 0,

  /**
   * @generated from enum value: WIN = 1;
   */
  WIN = 1,

  /**
   * @generated from enum value: EXHAUSTIVE_DRAW = 2;
   */
  EXHAUSTIVE_DRAW = 2,

  /**
   * @generated from enum value: ABORTIVE_DRAW = 3;
   */
  ABORTIVE_DRAW = 3,

  /**
   * @generated from enum value: ABORTED_BY_SERVER = 4;
   */
  ABORTED_BY_SERVER = 4,

  /**
   * a chonbo (design 14 §6.6): as if the hand never happened; the same hand is dealt anew
   *
   * @generated from enum value: VOIDED = 5;
   */
  VOIDED = 5,
}

/**
 * Describes the enum mj.record.v1.HandEnd.Outcome.
 */
export const HandEnd_OutcomeSchema: GenEnum<HandEnd_Outcome> = /*@__PURE__*/
  enumDesc(file_mj_record_v1_record, 32, 0);

/**
 * @generated from message mj.record.v1.GameEnd
 */
export type GameEnd = Message<"mj.record.v1.GameEnd"> & {
  /**
   * @generated from field: repeated int32 points = 1;
   */
  points: number[];

  /**
   * 1..seats per seat; ties share the better placement
   *
   * @generated from field: repeated uint32 placement = 2;
   */
  placement: number[];

  /**
   * hanchan score × 1000 (uma applied, oka applied), per seat
   *
   * @generated from field: repeated int32 score_x1000 = 3;
   */
  scoreX1000: number[];

  /**
   * @generated from field: uint32 leftover_sticks = 4;
   */
  leftoverSticks: number;

  /**
   * SHA-256 over canon of every hand's HandStart, events and HandEnd, then GameEnd (Appendix A)
   *
   * @generated from field: bytes event_stream_hash = 5;
   */
  eventStreamHash: Uint8Array;

  /**
   * SHA-256 over the canonical final state
   *
   * @generated from field: bytes final_state_hash = 6;
   */
  finalStateHash: Uint8Array;

  /**
   * @generated from field: mj.record.v1.GameEnd.Reason ended_reason = 7;
   */
  endedReason: GameEnd_Reason;

  /**
   * Ed25519 over "mj-end-sig-v1" ‖ L(game_id) ‖ event_stream_hash ‖ final_state_hash ‖ server_seed ‖ u64le(ended_at).
   *
   * @generated from field: bytes server_signature = 8;
   */
  serverSignature: Uint8Array;

  /**
   * @generated from field: bytes key_id = 9;
   */
  keyId: Uint8Array;

  /**
   * unix seconds, signed; host-supplied, not in canon (the core has no clock)
   *
   * @generated from field: uint64 ended_at = 10;
   */
  endedAt: bigint;
};

/**
 * Describes the message mj.record.v1.GameEnd.
 * Use `create(GameEndSchema)` to create a new message.
 */
export const GameEndSchema: GenMessage<GameEnd> = /*@__PURE__*/
  messageDesc(file_mj_record_v1_record, 33);

/**
 * COMPLETED: played to the end (seats that abandoned are still in it; design 6 G8); ABANDONED: every seat
 * left and the server dissolved the table (unrated); ABORTED_BY_SERVER: the server stopped the game
 * (crash, shutdown, private-table Leave).
 *
 * @generated from enum mj.record.v1.GameEnd.Reason
 */
export enum GameEnd_Reason {
  /**
   * @generated from enum value: REASON_UNSPECIFIED = 0;
   */
  REASON_UNSPECIFIED = 0,

  /**
   * @generated from enum value: COMPLETED = 1;
   */
  COMPLETED = 1,

  /**
   * @generated from enum value: ABANDONED = 2;
   */
  ABANDONED = 2,

  /**
   * @generated from enum value: ABORTED_BY_SERVER = 3;
   */
  ABORTED_BY_SERVER = 3,
}

/**
 * Describes the enum mj.record.v1.GameEnd.Reason.
 */
export const GameEnd_ReasonSchema: GenEnum<GameEnd_Reason> = /*@__PURE__*/
  enumDesc(file_mj_record_v1_record, 33, 0);

/**
 * @generated from enum mj.record.v1.VariantId
 */
export enum VariantId {
  /**
   * @generated from enum value: VARIANT_UNSPECIFIED = 0;
   */
  VARIANT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: RIICHI = 1;
   */
  RIICHI = 1,

  /**
   * @generated from enum value: TAIWANESE = 2;
   */
  TAIWANESE = 2,

  /**
   * @generated from enum value: CHANGSHA = 3;
   */
  CHANGSHA = 3,

  /**
   * @generated from enum value: MCR = 4;
   */
  MCR = 4,

  /**
   * @generated from enum value: HONG_KONG = 5;
   */
  HONG_KONG = 5,
}

/**
 * Describes the enum mj.record.v1.VariantId.
 */
export const VariantIdSchema: GenEnum<VariantId> = /*@__PURE__*/
  enumDesc(file_mj_record_v1_record, 0);

/**
 * @generated from enum mj.record.v1.Visibility
 */
export enum Visibility {
  /**
   * @generated from enum value: VISIBILITY_UNSPECIFIED = 0;
   */
  VISIBILITY_UNSPECIFIED = 0,

  /**
   * every seat and every spectator sees it as it happens
   *
   * @generated from enum value: PUBLIC = 1;
   */
  PUBLIC = 1,

  /**
   * only `seat` sees the payload as it happens
   *
   * @generated from enum value: SEAT = 2;
   */
  SEAT = 2,

  /**
   * nobody sees it during play
   *
   * @generated from enum value: OMNISCIENT = 3;
   */
  OMNISCIENT = 3,
}

/**
 * Describes the enum mj.record.v1.Visibility.
 */
export const VisibilitySchema: GenEnum<Visibility> = /*@__PURE__*/
  enumDesc(file_mj_record_v1_record, 1);

/**
 * @generated from enum mj.record.v1.ActionType
 */
export enum ActionType {
  /**
   * @generated from enum value: ACTION_UNSPECIFIED = 0;
   */
  ACTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DISCARD = 1;
   */
  DISCARD = 1,

  /**
   * @generated from enum value: CHI = 2;
   */
  CHI = 2,

  /**
   * @generated from enum value: PON = 3;
   */
  PON = 3,

  /**
   * @generated from enum value: OPEN_KAN = 4;
   */
  OPEN_KAN = 4,

  /**
   * @generated from enum value: ADDED_KAN = 5;
   */
  ADDED_KAN = 5,

  /**
   * @generated from enum value: CLOSED_KAN = 6;
   */
  CLOSED_KAN = 6,

  /**
   * @generated from enum value: RON = 7;
   */
  RON = 7,

  /**
   * @generated from enum value: TSUMO = 8;
   */
  TSUMO = 8,

  /**
   * @generated from enum value: PASS = 9;
   */
  PASS = 9,

  /**
   * @generated from enum value: DECLARE_RIICHI = 10;
   */
  DECLARE_RIICHI = 10,

  /**
   * @generated from enum value: ABORTIVE_DRAW = 11;
   */
  ABORTIVE_DRAW = 11,

  /**
   * @generated from enum value: DECLARE_STARTING_HAND = 12;
   */
  DECLARE_STARTING_HAND = 12,

  /**
   * @generated from enum value: TAKE_LAST_TILE = 13;
   */
  TAKE_LAST_TILE = 13,

  /**
   * @generated from enum value: KITA = 14;
   */
  KITA = 14,
}

/**
 * Describes the enum mj.record.v1.ActionType.
 */
export const ActionTypeSchema: GenEnum<ActionType> = /*@__PURE__*/
  enumDesc(file_mj_record_v1_record, 2);

